import {
	SET_ERROR_LIST,
	CLEAR_ERROR_LIST,
	CLEAR_ERROR_ELEMENTS_LIST,
	SET_ERROR_DETAIL_LIST,
	SHOW_ERROR_DETAILS
} from '../actionTypes/ErrorSetupActionTypes';
// import { getUserInfo } from '../../Utils/UserFunctions';

const initialState = {
	isErrorModalOpen: false, 
	isErrorElementsModalOpen: false, 
	showErrorDetails:false,
  	errorsList:[],
  	errorsDetailList:{}
};

const ErrorSetupReducer = (state = initialState, action) => {
	const {type,payload} = action;
	let updateErrorLists = null;
	// let isShow = false;
	switch (type) {
		case SET_ERROR_LIST:
	        updateErrorLists = [...payload];
	        return {
	            ...state,
	            isErrorModalOpen:true,
	            isErrorElementsModalOpen: true, 
	            errorsList:updateErrorLists
	        }
	    case CLEAR_ERROR_LIST:
	        updateErrorLists = [...payload];
	        return {
	            ...state,
	            isErrorModalOpen:false,
	            isErrorElementsModalOpen: false,
	            errorsList:updateErrorLists
	        }
	    case CLEAR_ERROR_ELEMENTS_LIST:
	        //updateErrorLists = [...payload];
	        return {
	            ...state,
	            isErrorElementsModalOpen: false,
	        }
	    case SET_ERROR_DETAIL_LIST:
	    	updateErrorLists = payload;
	        return {
	            ...state,	            
	            errorsDetailList:updateErrorLists
	        }
	    case SHOW_ERROR_DETAILS:
	    	// isShow = payload;
	        return {
	            ...state,	            
	            showErrorDetails:!state.showErrorDetails
	        }
	    default:
      		return state;
	}
}

export default ErrorSetupReducer;